import { Navigate, useLocation } from 'react-router-dom';
import { boxPathKeeping, type BoxKey } from './approval-box-types';

/**
 * 옛 문서함 주소 → 결재함 마디 (2026-09-13 · 과제 L2). 라우터가 `LEGACY_BOX_REDIRECTS` 표로 줄마다 세운다.
 * ★ 2026-09-14 — 옛 주소의 쿼리 · 해시를 버리지 않는다(#1252 리뷰 비차단).
 */
export function LegacyBoxRedirect({ box }: { box: BoxKey }): JSX.Element {
  const { search, hash } = useLocation();
  return <Navigate to={boxPathKeeping(box, search, hash)} replace />;
}
